import {useSelector} from 'react-redux';
import {useMemo} from 'react';
import type {UserShowResponseCompanySpacesInner} from '../generated-api';
import {selectAuthUser} from 'store/selectors';

/**
 * The company space is identified by the host the app is served from -- the
 * same way the AngularJS shell resolves it.
 */
export const useCurrentSpace = (): UserShowResponseCompanySpacesInner | undefined => {
    const authUser = useSelector(selectAuthUser);
    const spaces = authUser?.company_spaces;

    return useMemo(() => {
        const host = window.location.hostname.toLowerCase();
        const subdomain = host.split('.')[0];
        return spaces?.find((space) => space.custom_domain === host || space.subdomain === subdomain);
    }, [spaces]);
};

export interface MandatoryParams {
    job_title?: boolean;
    department?: boolean;
    birth_date?: boolean;
    personal_id?: boolean;
}

/**
 * Which user attributes the space collects at all -- the same switches the
 * AngularJS screens use to hide the fields. Swagger types it as a string,
 * but the API sends an object of flags.
 */
export const useMandatoryParams = (): MandatoryParams => {
    const space = useCurrentSpace();
    return (space?.mandatory_params as unknown as MandatoryParams) || {};
};

export const useIsKindOfAdmin = (): boolean => {
    const space = useCurrentSpace();
    // no space means a private space, where the user manages everything
    return !space || space.user_role === 'admin' || space.user_role === 'owner';
};
